import script from "./FilterVerb.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterVerb.vue?vue&type=script&setup=true&lang=js"

import "./FilterVerb.vue?vue&type=style&index=0&id=417b7b2c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-417b7b2c"]])

export default __exports__